/* TU horizontal scroll navigation: upgrades any [data-tu-hscroll] container with
   left/right arrow buttons instead of relying on the bare scrollbar.

   It also parks the scroller on the product the shopper is actually looking
   at. A compare table that opens on its cheapest column makes the reader
   hunt for their own product before the table means anything (owner, 8 Sep
   2026). Put data-tu-focus on the current column and
   data-tu-hscroll-focus="center" or "start" on the container. */
(function () {
  'use strict';
  if (window.tuHscrollInit) return;
  window.tuHscrollInit = true;

  var css = document.createElement('style');
  css.textContent =
    '.tu-hs{position:relative;}' +
    '.tu-hs__btn{position:absolute;top:var(--tu-hs-btn-top,50%);transform:translateY(-50%);z-index:5;width:3.6rem;height:3.6rem;border-radius:50%;border:1px solid rgba(0,0,0,.12);background:rgba(255,255,255,.95);box-shadow:0 2px 8px rgba(0,0,0,.14);cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;color:#121212;}' +
    '.tu-hs__btn:hover{background:#fff;border-color:rgba(0,0,0,.3);}' +
    '.tu-hs__btn--l{left:0.4rem;}.tu-hs__btn--r{right:0.4rem;}' +
    '.tu-hs__btn[hidden]{display:none;}' +
    '.tu-hs [data-tu-hscroll]{scrollbar-width:none;}' +
    '.tu-hs [data-tu-hscroll]::-webkit-scrollbar{display:none;}';
  document.head.appendChild(css);

  var arrow = function (dir) {
    return '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="' +
      (dir < 0 ? 'M10 3 L5 8 L10 13' : 'M6 3 L11 8 L6 13') + '"></path></svg>';
  };

  function upgrade(el) {
    if (el.closest('.tu-hs')) return;
    var wrap = document.createElement('div');
    wrap.className = 'tu-hs';
    el.parentNode.insertBefore(wrap, el);
    wrap.appendChild(el);
    var bl = document.createElement('button');
    var br = document.createElement('button');
    bl.type = br.type = 'button';
    bl.className = 'tu-hs__btn tu-hs__btn--l';
    br.className = 'tu-hs__btn tu-hs__btn--r';
    bl.setAttribute('aria-label', 'Scroll left');
    br.setAttribute('aria-label', 'Scroll right');
    bl.innerHTML = arrow(-1);
    br.innerHTML = arrow(1);
    wrap.appendChild(bl);
    wrap.appendChild(br);
    /* Park on [data-tu-focus] WITHOUT scrollIntoView, which would drag the
       whole page down to the table on load. Only scrollLeft moves.

       `touched` stops us fighting the reader: once they have scrolled the
       row themselves, their position is the right one and we never move it
       again. */
    var touched = false;
    function focus() {
      if (touched) return;
      var mode = el.getAttribute('data-tu-hscroll-focus');
      if (!mode) return;
      var target = el.querySelector('[data-tu-focus]');
      if (!target) return;
      var max = el.scrollWidth - el.clientWidth;
      if (max < 8) return;
      var er = el.getBoundingClientRect();
      var tr = target.getBoundingClientRect();
      var left = el.scrollLeft + (tr.left - er.left);
      if (mode === 'center') left -= (el.clientWidth - tr.width) / 2;
      else {
        /* "sticky": leave room for the frozen label column, or the current
           model parks underneath it and looks missing. */
        var pad = el.getAttribute('data-tu-hscroll-pad');
        if (pad === 'sticky') {
          var frozen = el.querySelector('[data-tu-sticky]');
          pad = frozen ? frozen.getBoundingClientRect().width : 0;
        }
        left -= (parseFloat(pad) || 0);
      }
      el.scrollLeft = Math.max(0, Math.min(left, max));
    }

    /* Park the buttons over the product images rather than halfway down.
       Centred, they land on the spec rows and cover the frozen row label,
       which is the one thing that must stay readable (owner, 8 Sep 2026).
       Anchored to an element, they follow it whatever the header height. */
    function place() {
      var anchor = el.querySelector('[data-tu-hs-anchor]');
      if (!anchor) return;
      var ar = anchor.getBoundingClientRect();
      var wr = wrap.getBoundingClientRect();
      if (!ar.height) return;
      wrap.style.setProperty('--tu-hs-btn-top',
        Math.round(ar.top - wr.top + ar.height / 2) + 'px');
    }

    function update() {
      var max = el.scrollWidth - el.clientWidth;
      var none = max < 8;
      bl.hidden = none || el.scrollLeft <= 4;
      br.hidden = none || el.scrollLeft >= max - 4;
    }
    bl.addEventListener('click', function () { el.scrollBy({ left: -el.clientWidth * 0.75, behavior: 'smooth' }); });
    br.addEventListener('click', function () { el.scrollBy({ left: el.clientWidth * 0.75, behavior: 'smooth' }); });
    el.addEventListener('scroll', update, { passive: true });
    /* Anything the reader does counts as taking over; the arrow buttons do
       not, which is why they set the flag back. */
    ['pointerdown', 'wheel', 'touchstart', 'keydown'].forEach(function (ev) {
      el.addEventListener(ev, function () { touched = true; }, { passive: true });
    });
    window.addEventListener('resize', function () { update(); place(); });
    if ('ResizeObserver' in window) new ResizeObserver(function () { update(); place(); }).observe(el);
    /* Images decide the column widths, so the first pass can land on a
       half-measured table; re-run once they have settled. */
    setTimeout(function () { focus(); update(); place(); }, 300);
    if (document.readyState !== 'complete') {
      window.addEventListener('load', function () { focus(); update(); place(); }, { once: true });
    }
    /* Re-assert once the row is actually on screen. A section far down the
       page can have its horizontal position reset before it is ever seen:
       the browser adjusts scroll containers on anchor and focus handling,
       and any scrollIntoView on an ancestor moves BOTH axes. */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          focus();
          update();
          place();
          io.disconnect();
        });
      }, { threshold: 0.15 });
      io.observe(el);
    }
    focus();
    update();
    place();
  }

  function init() { document.querySelectorAll('[data-tu-hscroll]').forEach(upgrade); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
